/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*SLICK SLIDER */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* BOX OF THE MONTH JS */

$(".fancy-collapse-panel [data-toggle=collapse]").on("click", function(){
    if($(this).closest(".panel-heading").hasClass("active")){
        $("#"+ $(this).attr("aria-controls")).slideUp();
        $(this).closest(".panel-heading").removeClass("active")
    }else{
        $(this).closest(".panel-heading").addClass("active")
        $("#"+ $(this).attr("aria-controls")).slideDown();
    }
})

$(".new-btn--load-video").on("click", function(){
    $(".box-of-mon-video-wrap .box-of-mon-video-item--hidden").removeClass("box-of-mon-video-item--hidden")
    $(this).hide();
  	return false;
});


async function ipLocationCall(){
    // Used to call internal ip geo location detection service.
    var cntObj = {};
    if(localStorage.getItem("ciplookup") != null){
  		cntObj = JSON.parse(localStorage.getItem("ciplookup"));
    }else{    
      await fetch("https://appbundle.bariatricpal.com/Home/iplookupmain").then(s=>s.json()).then(s=> { cntObj = s });
      localStorage.setItem("ciplookup", JSON.stringify(cntObj));
    }
    
    return { country_code : cntObj.countryCode, province_code :  cntObj.region }
}

async function checkColdPackStates()
{
      console.log('check cold pack state');

        // Set local variable for state allowed for ColdPack service.
      var geoLoc  =  await Rebuy.getGeolocation()
      
      if(geoLoc.province_code == null){
        geoLoc = await ipLocationCall();        
      }
  
      if((geoLoc.country_code == "US" && (window.theme.cart_cold_allowedstateabb.includes(geoLoc.province_code)))  || 
         (geoLoc.country_code != "US" && window.theme.cart_cold_allowedstateabb.includes('XX'))  || (geoLoc.province_code == null) )
      {
          console.log(geoLoc.province_code);
          window.theme.IsColdPackSbbAllowed = true;
      }else{
        window.theme.IsColdPackSbbAllowed = false;
      }
  
}
    
function addColdServiceNoticeToDrawer(){

  if(document.querySelector("[data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04'] #coldnoticebutton") == null){
  /*--  coldnoticebutton div is placed in Rebuy SAMRT Cart Widget, only visible based on below code -- */
    document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton").classList.remove("mehidden");
  }else if(document.querySelector("[data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04'] #coldnoticebutton") != null){
    document.querySelector("[data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04'] #coldnoticebutton").classList.remove("mehidden");
  }
  	/*<div id="coldnoticebutton">
		<a data-tooltip="Your order contains heat-sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. If you decline cold pack service you accept the risk of heat-damaged products." class="rebuy-button block" title="Your order contains heat sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. " style="background: #d44b3c;border-color: #d44b3c;cursor: pointer;"> Add Cold Pack Service - $3.99</a> 
	</div>*/
    	
}
function removeColdServiceNoticeToDrawer(){
  if(document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton") != null)
  	document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton").classList.add("mehidden");    	
  
  if(document.querySelector("[data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04'] #coldnoticebutton") != null){
    document.querySelector("[data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04'] #coldnoticebutton").classList.add("mehidden");
  }
}

function addColdPackServiceInCart(forceAdd)
{
              setCookie("coldserviceadded" + Rebuy.Cart.cart.token,1);
                
                  var addData = {
                    'id':window.theme.cart_cold_service_product_vid, 
                    'quantity':1,
                    'properties': {
                           '_Offer': 'FREE'
                     }
                  };

                  fetch(window.routes.cartAddUrl + '.js', {
                    body: JSON.stringify(addData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                    },
                    method: 'POST'
                  }).then(function(response) {
                    return response.json();
                  }).then(function(json) {
                    /* we have JSON */
                    console.log("---- HEAT SENSITIVE COLD-SERVICE ADDED",json)

                    setCookie("csautoadd" + Rebuy.Cart.cart.token,1);                    
                      if(forceAdd == true){
                        removeColdServiceNoticeToDrawer();
                        window.theme.cartattributeupdate=true;
                      }
                    
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  }).catch(function(err) {
                    /* uh oh, we have error. */
                    console.error(err)
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  });

  return false;
}
  
function heatSensitiveService(forceAdd)
{
  	removeColdServiceNoticeToDrawer();
    var itmttl = 0;
    window.coldpackrequire = false; // used only in this method.
    var atleastonefound = false;
    if(window.theme.IsColdPackSbbAllowed == false){
        return;
    }
  
	window.Rebuy.Cart.getItems().forEach(function(p, index){ 
          	var phandle = p.handle;
      		fetch("/products/"+ phandle +".json").then(s=>s.json()).then(function(data){ 

              itmttl++;
              if(data.product.tags.includes(window.theme.cold_pack_heatsensitive_tag))
              {
                window.coldpackrequire = true;
                setCookie("coldservicerequired"+Rebuy.Cart.cart.token, 1);
                var yesExists = window.Rebuy.Cart.getItems().find(s=>s.handle == window.theme.cart_cold_service_product_handle);
                if(yesExists != null){
                	setCookie("coldserviceadded"+Rebuy.Cart.cart.token,1);
                  	removeColdServiceNoticeToDrawer();
                  	
                }else if (forceAdd != true && forceAdd != null && getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                  // Customer intensionally removed this cold pack item. So add RED button again.
                  // add div to rebuy drawer.
                  addColdServiceNoticeToDrawer();                  
                  setCookie("coldserviceadded" + Rebuy.Cart.cart.token,0);
                } else {
                  	setCookie("coldserviceadded" + Rebuy.Cart.cart.token,0);
                  
                  	// add div to rebuy drawer.
                  	addColdServiceNoticeToDrawer();
                }

                if(getCookie("csautoadd" + Rebuy.Cart.cart.token) == "1" && forceAdd != true){
                    return;
                }

                var ctotal = window.Rebuy.Cart.subtotal() / 100;
                
                if((forceAdd == true || parseFloat(window.theme.cart_cold_service_amount) <= ctotal)  && (getCookie("coldserviceadded" + Rebuy.Cart.cart.token) != "1") 
                  && yesExists == null && atleastonefound == false)
                {
                    atleastonefound = true; // so that Adding cold pack will execute ONE time in Loop of Cart Line items
                  
              		// Yes cart have heat sensitive item, add extra service product. 
                    addColdPackServiceInCart();
                    removeColdServiceNoticeToDrawer();
                }

              }

              if(itmttl == window.Rebuy.Cart.getItems().length && window.coldpackrequire == false && 
                 getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                  // COLD SHOT NOT REQUIRED. & PREENT IN CART. SO REMOVE IT.
                  var removeData = { 'id': window.theme.cart_cold_service_product_vid, 'quantity': 0 }; 
                  fetch('/cart/change.js', {
                    body: JSON.stringify(removeData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' 
                    },
                    method: 'POST'
                  }).then(s=>s.json()).then(function(data){
                      window.theme.cartattributeupdate=true;
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                  });
              }
              
            });    
		})
    
    return false;
}    
    

/*
 * Product page. Frequently Bought Together
 */
function fbtMoveContent() {
    if (!$('.cbb-frequently-bought-container').hasClass('loaded') && $('.cbb-frequently-bought-selector-list li').length > 0) {
        var productsList = $('.cbb-frequently-bought-products li');
        var selectorsList = $('.cbb-frequently-bought-selector-list li');

        $('.cbb-frequently-bought-products').addClass('product_size' + productsList.length);

        $('.cbb-frequently-bought-product').each(function() {
            $(this).html('<div class="cbb-frequently-bought-product__wrap">' + $(this).html() + '</div>');
            $(this).find('.cbb-frequently-bought-product__wrap').append('<span class="cbb-frequently-bought-product__added"><i></i></span>');
        });

        for (var i = 0; i < productsList.length; i++) {
            $(productsList[i]).append('<div class="cbb-frequently-bought-product__meta"></div>');
          
          	$(productsList[i]).find('.cbb-frequently-bought-product__meta').append($(selectorsList[i]).find('.cbb-frequently-bought-rating-box'));
          
            $(productsList[i]).find('.cbb-frequently-bought-product__meta').append($(selectorsList[i]).find('.cbb-frequently-bought-selector-label-name'));
            $(productsList[i]).find('.cbb-frequently-bought-product__meta').append($(selectorsList[i]).find('.cbb-frequently-bought-selector-label-price'));
            $(productsList[i]).find('.cbb-frequently-bought-product__meta').append($(selectorsList[i]).find('.cbb-frequently-bought-selector-label-compare-at-price'));
            $(productsList[i]).find('.cbb-frequently-bought-product__meta').append($(selectorsList[i]).find('.cbb-recommendations-variant-select'));
          	
            //$(productsList[i]).find(".cbb-frequently-bought-product__meta").append("<div class='cbbfbtreview'><div class='yotpo bottomLine' data-appkey='QbUo81vSKO3QyWipOdWy2yOQqQ2fiDCfp65r7AWI' data-product-id=''></div>")
        }


        $('.cbb-frequently-bought-product').on('click', function() {
            $(this).toggleClass('cbb-frequently-bought-product--disabled');
            selectorsList.eq($(this).index()).find('.cbb-frequently-bought-selector-input').trigger('click');

            return false;
        }).find('.cbb-recommendations-variant-select').click(function(e) {
            return false;
        }); //exclude select element from Click method

		// Click on Title will redirect
      	$('.cbb-frequently-bought-selector-label-name').on('click', function() {
      		window.location = $(this).closest(".cbb-frequently-bought-product").find(".cbb-frequently-bought-product__wrap a").attr("href");
      	});
      
        $('.cbb-frequently-bought-products .cbb-recommendations-variant-select').change(function() {
            var productIndex = $(this).closest('.cbb-frequently-bought-product').index();

            $('.cbb-frequently-bought-selector-list li:nth-child(' + (productIndex + 1) + ')').find('.cbb-recommendations-variant-select').val($(this).val()).change();
        });
      
      	

        $('.cbb-frequently-bought-container').addClass('loaded');
    }
}

$(function() {
    /*if ($("body.template-product").length == 1 && $('#cbb-frequently-bought-box').length > 0) {
        setTimeout(fbtMoveContent, 1000);
        setTimeout(fbtMoveContent, 2000);
        setTimeout(fbtMoveContent, 3000);
        setTimeout(fbtMoveContent, 4000);
        setTimeout(fbtMoveContent, 5000);
        setTimeout(fbtMoveContent, 7000);
        setTimeout(fbtMoveContent, 9000);
        setTimeout(fbtMoveContent, 12000);
    }
    	CBB frequently bought together fix
    */
  
  	rewardPageInitial();
  
  
  	// For meal pages
  	$('.recipe-accordion__label').on('click', function(e) {
            e.preventDefault();

            $(this).toggleClass('active').next('.recipe-accordion__item-wrap').slideToggle();
    });
  	$("#meal-plans > .accordion .accordion-label").on("click", function(){
        
        $("#meal-plans .accordion").find("input[name='item']").not($(this).parent().children("input[name='item']")).attr("previousvalue", "false");
        if($(this).parent().children("input[name='item']").attr("previousvalue") == "false")
            $(this).parent().children("input").attr("previousvalue", "checked");
        else
            $(this).parent().children("input").attr("previousvalue", "false");
    
        return false;
	});
  
  	$("#surgeryplans .accordion-item.leveltwo .accordion-label, #surgeryplans > .accordion > .accordion-item .accordion-label.first-level").on("click", function(){
        
        $(this).find("input[name='item']").attr("previousvalue", "false");
        if($(this).parent().children("input[name='item']").attr("previousvalue") == "false")
            $(this).parent().children("input").attr("previousvalue", "checked");
        else
            $(this).parent().children("input").attr("previousvalue", "false");
    
        return false;
	});
  
  
  	// for box of the month
    if($("body .box-for-month__program").length > 0){
      SaveCntryInfo();
      hideProductForNotAllowCountry();
      
      restrictOutsideUS();
      
    }
  
});    
    
function rewardPageInitial()
{
	 $(document).on("swell:setup", function() {
        var referredCustomersInput = $("#rewardFriendsEmails");
        var sendEmailsBtn = $("#referred-customers-send-btn");

        var details = swellAPI.getCustomerDetails();
        if (details == undefined || details.email == undefined) {
            // show capture referrer email screen (or just show that by default and then hide it if there is an identified customer)

            //$("#myEmailModal").modal("show");
            //$("#referrer-email").focus();

        } else {
            $("#blockRLink").show();
            // show share screen, details is same object as details in success callback above
            // We have email and referrer code.
        }


        $(sendEmailsBtn).click(function() {
            $("#errorBlockREmail").hide();
            // assuming you allowed comma separated email input
            var emails = referredCustomersInput.val().split(",");
            if (emails == "") {
                $("#errorBlock").find(".label").html("Please provide valid email address.");
                $("#errorBlock").show();
                return;
            }
            $("#successBlock").hide();
            $("#errorBlock").hide();

            var details = swellAPI.getCustomerDetails();
            if (details == undefined || details.email == undefined) {
                // show capture referrer email screen (or just show that by default and then hide it if there is an identified customer)

                $("#myEmailModal").modal("show");
                $("#referrer-email").focus();
                return;
            }

            var onSuccess = function() {
                $("#successBlock").show();
                $("#rewardFriendsEmails").val("");
            }

            var onError = function(err) {
                $("#errorBlock").find(".label").html("Something went wrong. Please try again.");
                $("#errorBlock").show();
            }

            swellAPI.sendReferralEmails(emails, onSuccess, onError);

        });

        $("#referrer-email-submit-btn").click(function() {

            var email = $("#referrer-email").val();
            // could add some of your own client side validation here if you'd like to make sure email is valid
            $("#errorBlockREmail").hide();
            // success callback.  called after email is registered with Swell
            var onSuccess = function(details) {
                // can show share referral with friends screen

                // if you want to use referral code/link it's accessible via the details object passed to success callback
                // details.referralCode is referrer's unique referral code with swell (e.g. "abc123")
                // details.referralLink is the full referral link (e.g. "http://rwrd.io/abc123") 
                $("#successBlockREmail").show();
                $("#rewardFriendsEmails").focus();
                $("#blockRLink").show();
                setTimeout(function() {
                    $("#myEmailModal").modal("hide");
                }, 4000);

            }

            // error callback.  called if swell deems the email invalid   
            var onError = function() {
                // show customer invalid email error message
                $("#errorBlockREmail").show();
            }
            swellAPI.identifyReferrer(email, onSuccess, onError);

        });
    });
}
    
var $slick_logo = $('body:not(.template-index) .logo-list-title-section .logo-bar');
var settings_logo = {
          slidesToShow: 2,
          slidesToScroll: 2,
          mobileFirst: true,
          arrows: false,
          dots: true,
          responsive: [{
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 4
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 3
                  }
              }
          ]
};
    
// $(function() {
// 	if ($(window).width() < 920) {
//     	$slick_logo.slick(settings_logo);
//     }
// });

//     // reslick only if it's not slick()
//     $(window).on('resize', function() {
//         if ($(window).width() > 920) {
//             if ($slick_logo.hasClass('slick-initialized')) {
//                 $slick_logo.slick('unslick');
//             }
//             return
//         }

//         if (!$slick_logo.hasClass('slick-initialized')) {
//             return $slick_logo.slick(settings_logo);
//         }
//     });
    
    
function reinitYotpoAfterSeconds(sec){
	setTimeout(function(){
    	if(typeof Yotpo == "function" && $(".cbbfbtreview .yotpo-display-wrapper").length == 0 && $("#cbb-frequently-bought-box .cbb-frequently-bought-recommendations-container").length == 1 && $("body.template-product").length == 1){
          //REinit Yotpo
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();        
    	}
	}, 4000);
}


function writeReviewBtnClick(arg) {
    //$(".tabs li:last-child").find('a').click();
    if(arg=="question")
      document.querySelector(".ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs .ugc-storefront-widgets-tabs-container__tab:last-child").click();

    //setTimeout(function() {
        $("html, body").animate({
            scrollTop: document.querySelector("#yotpo-app").offsetTop - 100
        }, 300);
    //}, 700);

    return false;
}
function bindMoreReviewsLink() {
    if(document.querySelectorAll(".template-product .yotpo.yotpo-shoppers-say a.more-reviews").length>0)
    {
        document.querySelectorAll(".template-product .yotpo.yotpo-shoppers-say a.more-reviews").forEach(function(item){
            $(item).on("click",writeReviewBtnClick)
        });
    } else {
        setTimeout(bindMoreReviewsLink, 1000);
    }
}
function rebuyButtonVisibilityForFreeItem(){
  // TO HIDE FREE ITEM SUBSCRIPTIONS BUTTON IN REBUY CART DRAWER.
            document.querySelectorAll('[data-smartcart-items] .rebuy-cart__flyout-item-discount-message').forEach(function(discountMessage) {
                if (discountMessage.textContent.trim() === "Free Offer by BariatricPal") {
                    const liParent = discountMessage.closest('li.rebuy-cart__flyout-item');
                    if (liParent) {
                        const subscriptionElement = liParent.querySelector('.rebuy-cart__flyout-item-subscription');
                        if (subscriptionElement) {
                            subscriptionElement.remove();
                        }
                    }
                }
            });
}

/*REBUY SMART CART INTEGRATIONS */
document.addEventListener('rebuy.init', function(event){
  	console.log('rebuy.init event', event.detail);  
  // Call cold pack provinces
    checkColdPackStates();
  
});
document.addEventListener('rebuy:cart.change', function(event){
    	setTimeout(function(){
    		rebuySmartCartAfterChangeUpdates(event);
          
            if(typeof window.bppayLaterFunction.refreshCartHtmls == "function")
            {
              window.bppayLaterFunction.refreshCartHtmls();
            }
          
            if(window.theme.cartattributeupdate != true){
                //console.log("is wholesale customer heatsnsitive fired");
            	heatSensitiveService();
            }else{
              window.theme.cartattributeupdate = false;
            }

            rebuyButtonVisibilityForFreeItem();

          
        },500);
});

document.addEventListener('rebuy:smartcart.hide', function(event){
      //console.log('rebuy:smartcart.hide event', event.detail);
  	closeCart();  
});
    
document.addEventListener('theme:sliderpopupopened', function(event){
    // developer fired event from theme js file. to hide 3rd party widgets icons from screen
  	hideBottomWidgets();
});
document.addEventListener('theme:sliderpopupclosed', function(event){
    // developer fired event from theme js file. to SHOW 3rd party widget icons from screen
  	showBottomWidgets();
});
    
document.addEventListener('theme:loading:end', function(event){
	//console.log('rebuy:smartcart.hide event', event.detail);
  	 	if(typeof yotpo != "undefined")
        {
    		yotpo.initWidgets();
		}
});
document.addEventListener('rebuy:smartcart.show', function(event){
  $('html').addClass('blocked-scroll');	

   rebuyButtonVisibilityForFreeItem();
  
});


document.addEventListener('product:added', function(event) {
   var variant = event.detail.variant; // Get the variant that was added
   var quantity = event.detail.quantity; // Get the quantity that was added

    
    try {
      if(theme.FreeItemVariantId == variant.id){
          // execute only for one specific variant id - vendor based free gift item. 
          var itemExistsMoreThanOne = Rebuy.Cart.cart.items.filter(s=>  s.id == variant.id).length >= 1;
          console.log("--- PRODUCT ADDED ----", variant, quantity, itemExistsMoreThanOne);
          if(itemExistsMoreThanOne) {
            // remove and reload.
                          
              const removeCartItem = async (variantId) => {
                const shopifyCartUrl = '/cart/update.js';
              
                const response = await fetch(shopifyCartUrl, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    updates: {
                      [variantId]: 0,
                    },
                  }),
                });
              
                if (response.ok) {
                  console.log('Cart item removed successfully.');
                } else {
                  console.error('Failed to remove cart item.');
                }
              };
              
              // Usage example
              const variantId = theme.FreeItemVariantId;
              removeCartItem(variantId);
            
            // end of remove code
          }  
      }      
    } catch (error) {
      
    }
});
    
function OpenSmartCart()
{  
  if(window.Rebuy != undefined && window.Rebuy.SmartCart != null){
	// Disable preview mode
	//window.Rebuy.SmartCart.settings.preview_mode = false;
	//Open Smart Cart
	Rebuy.SmartCart.show()
  }
}

function HideSmartCart(){
	//Hide Smart Cart
	window.Rebuy.SmartCart.hide();
}

function FreeShippingBarInCartDrawer(){
  var freeUntil = 79;
  var ship_price = 0;
  if($('.cart_subtotal .actualtotal .money').length > 0){
  	ship_price = parseFloat($('.cart_subtotal .actualtotal .money').html().replace(/[^0-9.]/g, ""));
  }
	
  
  var diff = freeUntil - ship_price;
  if(ship_price == 0){
    $('.cart_text .cart__shipping-progress span').css('width', '0%');
    $('.cart_text p').html('FREE SHIPPING ON ALL ORDERS OVER $'+ freeUntil +'!');
  }
  else if(diff > 0) {
    var shipping_percent = ((ship_price * 100) / freeUntil);
    $('.cart_text .cart__shipping-progress span').css('width', shipping_percent + '%');
    
    var adddiff = freeUntil - ship_price; /* Was 100 */
    $('.cart_text p').html('ALMOST THERE! ADD $' + adddiff.toFixed(2) + ' TO UNLOCK FREE SHIPPING!');
    
  }
  else {
    $('.cart_text .cart__shipping-progress span').css('width', '100%');
    $('.cart_text p').html('CONGRATS! YOU HAVE UNLOCKED FREE SHIPPING!');
  }
}

function rebuySmartCartAfterChangeUpdates(cartData){ 
    // add item count on header
    $('.rebuy-cart__flyout-title').text('Your Cart ('+ cartData.detail.cart.cart.item_count +')')

    var items = cartData.detail.cart.cart.items;
  
    if( items.length > 0 ) {
      var icon = $('.rebuy-cart .rebuy-cart__checkout-button .rebuy-button-icon').clone()
      // $('.rebuy-cart .rebuy-cart__checkout-button').text('Checkout - ' + Shopify.formatMoney(cartData.detail.cart.cart.total_price, $('body').data('money-format')))
      // $('.rebuy-cart .rebuy-cart__checkout-button').prepend(icon)
      $('.rebuy-cart .rebuy-cart__checkout-button').html('Checkout - ' + Shopify.formatMoney(cartData.detail.cart.cart.total_price, window.shopMoneyFormat )).prepend(icon);
  
      setTimeout(function(){
        var rebuyCustomersAlsoBoughtElement = $(".rebuy-cart__flyout-recommendations");
        rebuyCustomersAlsoBoughtElement.find('.rebuy-product-block').each(function(){
          var el = $(this)
          el.find('.rebuy-product-actions').insertAfter( el.find('.rebuy-product-price') )
          el.find('.rebuy-product-options').insertBefore( el.find('.rebuy-product-price') )
        })
      },2000)
    }
  
  
    setTimeout(function(){
  
      var ctrItems = 0;
      $('.rebuy-cart__flyout-content.has-items .rebuy-cart__flyout-item').each(function(){
        var item = $(this)
  
        if(item.find('.rebuy-cart__flyout-item-price .sale span').length > 0){
          var sale =  item.find('.rebuy-cart__flyout-item-price .sale span').eq(1).text().replace(/,/g,"");
          sale = parseFloat(sale.substring(1, sale.length))
          var original =  item.find('.rebuy-cart__flyout-item-price .compare-at span').eq(1).text().replace(/,/g,"");
          original = parseFloat(original.substring(1, original.length))
    
          var percentageData = (((original - sale) / original) * 100).toFixed(0);
          var percent = `
            <div class="percentage 3">
              <span>Save `+ percentageData +`%</span>
            </div>
          `;
    
          item.find('.rebuy-cart__flyout-item-price .percentage').remove();
          item.find('.rebuy-cart__flyout-item-price').append(percent)
        }else{
          item.find('.rebuy-cart__flyout-item-price .percentage').remove();
        }
  
      })
  
      // for(var i = 0; i < items.length; i++ ){
      //   var item = items[i]
  
      //   var sale =  $('.rebuy-cart__flyout-items .product-'+item.handle).find('.rebuy-cart__flyout-item-price .sale span').eq(1).text();
      //   sale = parseFloat(sale.substring(1, sale.length))
      //   var original =  $('.rebuy-cart__flyout-items .product-'+item.handle).find('.rebuy-cart__flyout-item-price .compare-at span').eq(1).text();
      //   original = parseFloat(original.substring(1, original.length))
  
      //   var percentageData = (((original - sale) / original) * 100).toFixed(0);
      //   var percent = `
      //     <div class="percentage 3">
      //       <span>Save `+ percentageData +`%</span>
      //     </div>
      //   `;
  
      //   $('.rebuy-cart__flyout-items .product-'+item.handle).find('.rebuy-cart__flyout-item-price .percentage').remove();
      //   $('.rebuy-cart__flyout-items .product-'+item.handle).find('.rebuy-cart__flyout-item-price').append(percent)
        
      // }
  
      $('.rebuy-cart__flyout-recommendations .rebuy-product-block .percentage').remove();
      $('.rebuy-cart__flyout-recommendations .rebuy-product-block').each(function(){
        var el = $(this)
        //el.find('.rebuy-product-actions').insertAfter( el.find('.rebuy-product-price') )
  
  
        var sale =  el.find('.sale span').eq(1).text();
        if(sale != ""  && sale != " ") {
          
          sale = parseFloat(sale.substring(1, sale.length))
          var original =  el.find('.compare-at span').eq(1).text();
          original = parseFloat(original.substring(1, original.length))
    
          var percentageData = (((original - sale) / original) * 100).toFixed(0);
          var percent = `
            <div class="percentage">
              <span>Save `+ percentageData +`%</span>
            </div>
          `;
    
          el.find('.rebuy-product-price').append(percent);
          
        }
      })
      
    }, 2000)
    var giftAmt = 0; 
  	cartData.detail.cart.cart.items.forEach(function(item){ if(item.gift_card){ giftAmt += item.final_line_price; } });
  
  var boxofmonthAmt = 0; 
  	cartData.detail.cart.cart.items.forEach(function(item){ if(item.product_type == "Subscription Box"){ boxofmonthAmt += item.final_line_price; } });	 	
                          
  window.globalCartTotal = cartData.detail.cart.cart.total_price - giftAmt - boxofmonthAmt;
  
  //window.globalCartTotal = cartData.detail.cart.cart.total_price;	
  
  if(window.Rebuy.SmartCart.cart != null){
    		var total_savings = 0;
            var discounted_price_total = 0;
        		
    		window.Rebuy.SmartCart.cart.items.filter(function(citm){

               if(citm.selling_plan_allocation != null){
                     discounted_price_total += parseFloat((citm.selling_plan_allocation.price/100).toFixed(2)) * citm.quantity;
                    total_savings += parseFloat((citm.selling_plan_allocation.compare_at_price/100).toFixed(2)) * citm.quantity;
               }
              
              /*if(JSON.parse(localStorage.getItem("v" + citm.variant_id)) == null){
              	$.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + citm.handle + ".js",
                    success: function(data) {
                      var variant_id = citm.variant_id;
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == variant_id;
                      });

                      localStorage.setItem("v"+variant_id, JSON.stringify({ compare_at_price : variant[0].compare_at_price }));
                      if(variant[0] && variant[0].compare_at_price > citm.price) {                        
                        discounted_price_total += parseFloat((citm.price/100).toFixed(2)) * citm.quantity;
                        total_savings += parseFloat((variant[0].compare_at_price/100).toFixed(2)) * citm.quantity;
                      }
                    }
                  });
                }else{
                  // found in localstorage. 
                  var vitemzero = JSON.parse(localStorage.getItem("v" + citm.variant_id));
                  if(vitemzero && vitemzero.compare_at_price > citm.price) {                        
                      discounted_price_total += parseFloat((citm.price/100).toFixed(2)) * citm.quantity;
                      total_savings += parseFloat((vitemzero.compare_at_price/100).toFixed(2)) * citm.quantity;
                  }                
              	}   */
              
                
            });

      
      

      if( items.length > 0 ) {
        var total = Shopify.formatMoney(total_savings, $('body').data('money-format'))
        total = parseFloat(total.substring(1, total.length))
        var discount_total = Shopify.formatMoney(discounted_price_total, $('body').data('money-format'))
        discount_total = parseFloat(discount_total.substring(1, discount_total.length))


        var percentage = parseInt((( total - discount_total ) / total) * 100);
      }

    
    	if (total_savings > 0) {              
        	updateRebuySubTotalSavingText(percentage);
        } else {              
        	updateRebuySubTotalSavingText(null);
        }  
    
    	// UPDATE THEME'S CART ITEM COUNT
    	document.querySelector(".header__cart-count").innerText = window.Rebuy.SmartCart.cart.item_count;
    
  }
  
  if($("#rebuy-cart [data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04']").length == 1){
      var freebtncontainer = $("#rebuy-cart [data-rebuy-custom-code='4799d893-7dc1-484e-ba18-ff7f20d3da04']");
      // for smart cart v2.
      if(freebtncontainer.find("#freeItemOfferLink").length == 0 && boxofmonthAmt == 0)
      {
        if((parseFloat($("#freeSBox").attr("data-themesetting")) * 100) <  window.globalCartTotal && isFreeItemAdded(cartData.detail.cart.cart) == false){
          freebtncontainer.prepend('<button id="freeItemOfferLink" class="rebuy-button outline" onclick="selectSampleItem(this)" type="button">Select your free gift.  🎁 </button>');
        }
      }else if (isFreeItemAdded(cartData.detail.cart.cart) == true || window.globalCartTotal < (parseFloat($("#freeSBox").attr("data-themesetting")) * 100)){
        freebtncontainer.find("#freeItemOfferLink").remove();
      }

  }else{
    if($("#rebuy-cart .rebuy-cart__flyout-footer #freeItemOfferLink").length == 0 && boxofmonthAmt == 0){
        if((parseFloat($("#freeSBox").attr("data-themesetting")) * 100) <  window.globalCartTotal && isFreeItemAdded(cartData.detail.cart.cart) == false){
          $("#rebuy-cart .rebuy-cart__flyout-footer").prepend('<button id="freeItemOfferLink" class="rebuy-button outline" onclick="selectSampleItem(this)" type="button">Select your free gift.  🎁 </button>');
        }
      }else if (isFreeItemAdded(cartData.detail.cart.cart) == true || window.globalCartTotal < (parseFloat($("#freeSBox").attr("data-themesetting")) * 100)){
        $("#rebuy-cart .rebuy-cart__flyout-footer #freeItemOfferLink").remove();
      }
  }

  
  
  FreeItemBarRefreshDecide(window.Rebuy.SmartCart.cart);
}

function isFreeItemAdded(cartObj){  
  var isFreeitemadded = false; 
  cartObj.items.forEach(function(item){ if(item.properties && item.properties["_OfferItem"] != null){ isFreeitemadded = true; } });
  
  var boxofmonthAmt = 0; cartObj.items.forEach(function(item){ if(item.product_type == "Subscription Box"){ boxofmonthAmt += item.final_line_price; } });	 	
  if( cartObj.items.filter(d=>d.product_type == "Subscription Box").length >= 1 && cartObj.items.filter(d=>d.product_type != "Subscription Box").length == 0 )
  {
  	isFreeitemadded = true; 
  }
  
  return isFreeitemadded;
}

function updateRebuySubTotalSavingText(savingmoneytext){
  if (savingmoneytext != null) {
	$(".rebuy-cart__flyout-subtotal-label span").html("Subtotal <span class='cc_savings'>(Save <span class='money'>"+ savingmoneytext + "%</span>)</span>")
  } else {
  	$(".rebuy-cart__flyout-subtotal-label span").html("Subtotal");
  }
}


function FreeItemBarRefreshDecide(cartObj){
	if(typeof refreshFreeItemBar == "function" && cartObj != null){
            	var totalPrice = cartObj.total_price;
              var giftAmt = 0; cartObj.items.forEach(function(item){ if(item.gift_card){ giftAmt += item.final_line_price; } });              
              
              var isFreeitemadded = false; cartObj.items.forEach(function(item){ if(item.properties && item.properties["_OfferItem"] != null){ isFreeitemadded = true; } });
			  
            	var boxofmonthAmt = 0; cartObj.items.forEach(function(item){ if(item.product_type == "Subscription Box"){ boxofmonthAmt += item.final_line_price; } });	 	
              	if( cartObj.items.filter(d=>d.product_type == "Subscription Box").length >= 1 && cartObj.items.filter(d=>d.product_type != "Subscription Box").length == 0 )
                {
                    isFreeitemadded = true; 
                }

                if(cartObj.items.filter(d=>d.product_type == "Subscription Box").length >= 1)
                {        	
                    giftAmt = giftAmt + boxofmonthAmt;
                }
      
      			// METHOD DEFINITION IS INSIDE FREESAMPLE LIQUID SNIPPET
    			refreshFreeItemBar(cartObj.total_price - giftAmt, isFreeitemadded);
    }
}

function hideProductForNotAllowCountry(){
  // For US only allowed
  var isusa = IsCountryUSA();
  if($('div[allowcountry="US"] .add_to_cart[type="submit"]').length > 0 &&  isusa == false){
  	$('div[allowcountry="US"] .add_to_cart[type="submit"]').hide();
    $('div[allowcountry="US"] .add_to_cart[type="submit"]').parent().prepend('<div class="alert-danger">We are sorry but this product is only available within the US.</div>');
  }
  
  if($('.add_to_cart.action_button[data-allowcountry="US"]').length > 0 &&  isusa == false){
  	$('.add_to_cart.action_button[data-allowcountry="US"]').hide();
  }
  
  if(isusa == null){
  	// wait for 1 second and fire again. 
    setTimeout(hideProductForNotAllowCountry,1000);
  }
}
function IsCountryUSA(){
  if(localStorage.getItem("ciplookup") != null){
  		return JSON.parse(localStorage.getItem("ciplookup")).countryCode == "US";
  }else{
    SaveCntryInfo();
  	return null;
  }
}
function SaveCntryInfo(){
  	if(localStorage.getItem("ciplookup") == null){
			$.getJSON("https://appbundle.bariatricpal.com/Home/iplookupmain",
                function(json) {
            		if (json.country && (json.city)) {
                    	localStorage.setItem("ciplookup", JSON.stringify(json));                           
                	}
            	}
            );
    }
}
function clickedOnVideo(ctrl){
	ctrl.outerHTML = ctrl.outerHTML.replace(/viframe/g,"iframe");
  	//ctrl.outerHTML = ctrl.outerHTML.replace(/div/g,"iframe");
}

function closeCart() {
  $("html").removeClass("blocked-scroll");
  $("body").removeClass("blocked-scroll");
  $('.cart_close').parents('.cart_container').removeClass('active_link');
  
}
function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

    
function restrictOutsideUS() {
    // call geoip api
    jQuery.ajax({
        url: 'https://appbundle.bariatricpal.com/Home/iplookupmain',
        success: function(dd) {
            //console.log(JSON.parse(dd));
            var d = JSON.parse(dd);
            //console.log(d.country_code);
            if (d != null && d.countryCode != null && (d.countryCode != "US")) {
                // Show simple display message.
                var msg = "We are sorry but the BariatricPal Subscription Box is only available within the US.";
                $("<div class='alert-danger'>" + msg + "</div>").insertBefore($(".highlighted-back").first());

                //Hide Add to cart buttons.
                $(".program-product-box .product_form").remove();
            }
        }
    })
}
    
function buttonSubmitNotifyMeKlaviyo(ctrl)
{
  	var pdiv = $(ctrl).closest(".notify-custom");
	var klvkey = "bEzme8";
  	var cemail = $(pdiv).find("#txtEmail").val();  	
  	var variantid = $(pdiv).attr("data-vid");
  if(cemail == ""){ 
    $("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("Please enter email address.");
    return false;
  }
  
  		$.ajax({
          type: "GET",
          url: "https://appbundle.bariatricpal.com/GenMisc/CallKlaviyoBISAlert?emailaddr=" + cemail + "&variantid=" + variantid + "&acctkey=" + klvkey,
          success: function (data) {
            var dt = JSON.parse(data);
            if(dt.success == true){
    			$("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("Thanks! You will get a notification when it's back in stock.");
            }else{
            	$("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("There was something wrong with your request. Please try later.");
            }
            
          },
          error: function(data) {
            console.error(data);
            $("div.modal[aria-hidden='false'] .modal__inner .responseMsg").html("Alert service down. Sorry for any Inconvenience.");
          }
        });  
  
}
function closeAnnouncementbar(ctrl)
{
  setCookie("cabclose", "1", 1);
  refreshAnnouncementbar();
  return false;
}
function refreshAnnouncementbar()
{
  if(getCookie("cabclose") == "1"){
  	if(document.querySelector(".head-announcebar") != null){
      document.querySelector(".head-announcebar").remove();
    }
  }else{
    document.querySelector(".head-announcebar .announcement-bar").classList.remove("hidden");
  }
}
   
function hideBottomWidgets()
{
}
function showBottomWidgets()
{
}
    
    
function sendViewedProductEvent(item){
    if(typeof _learnq != "undefined")
  		_learnq.push(['track', 'Viewed Product', item]);
}

function sendAddProductEvent(item){
    if(typeof _learnq != "undefined")
  		_learnq.push(['track', 'Added to Cart', item]);
}
function productReChargeVariantEventBinding() {
    
      		document.addEventListener("variant:changed", function(e){
              		
                	// Subscription selected and variant change happens
                    if(ReCharge.products[0].elements[0].activePurchaseType.value == "autodeliver"){
                    	var dupvarid = ReCharge.products[0].variant_to_duplicate[e.detail.variant.id];
                		var dupPrice = ReCharge.products[0].duplicate_to_price[dupvarid];
                      
                      	var upPrice = Shopify.formatMoney(dupPrice, window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat)
                      	$(ReCharge.products[0].forms[0]).find(".product-form__info-item .current_price").html(upPrice);
                        $('.selected-price').html(upPrice);
                      
                    }
              		if(e.detail.variant.compare_at_price > e.detail.variant.price){
              			var savePrice = (e.detail.variant.compare_at_price - e.detail.variant.price);
                      	var savePercent = parseInt(((e.detail.variant.compare_at_price - e.detail.variant.price) * 100) / e.detail.variant.compare_at_price);
                      	document.querySelector(".yousavelbl").parentElement.querySelector("ssp").innerHTML = Shopify.formatMoney(savePrice, window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat) + " ("+savePercent+"%)"
              		}
                	                	             		
                	$("form .button.button--primary.klaviyo-bis-trigger").closest("div").show();
              		
              		if($(".swelRewardPoint[data-doublereward]").attr("data-doublereward") == "true")
                    {
              			$(".swelRewardPoint[data-doublereward]").html(parseInt((e.detail.variant.price * 2)/100));
                    }else{
                    	$(".swelRewardPoint[data-doublereward]").html(parseInt(e.detail.variant.price / 100));
                    }
              
                
              });
    
    }  
    
function productVariantChangeCallback(){
    	document.addEventListener("variant:changed", function(e){
  			$("form .button.button--primary.klaviyo-bis-trigger").closest("div").show();
              		if($(".swelRewardPoint[data-doublereward]").attr("data-doublereward") == "true")
                    {
              			$(".swelRewardPoint[data-doublereward]").html(parseInt((e.detail.variant.price * 2)/100));
                    }else{
                    	$(".swelRewardPoint[data-doublereward]").html(parseInt(e.detail.variant.price / 100));
                    }
  		});

    }

document.addEventListener("variant:changed", function(e) {
    var price = e.detail.variant.price;
    setTimeout(function() {
        var el = document.querySelector(".swelRewardPoint[data-doublereward]");
        if (!el) return;
        el.textContent = parseInt(
            el.getAttribute("data-doublereward") === "true"
                ? (price * 2) / 100
                : price / 100
        );
    }, 0);
});

/*KLARNA SHOPAY ICONS SETUP SCRIPT */    

  (function(){
  
    var bppayLaterFunction = function(){
    
      var cls = {
        
        settings : {
          productpage_containerdivid: "#payLaterButtons",
          productpage_initialprice : ".product_section .eleSezzelPrice .current_price .money",
          cartpage_totamamt_element: ".rebuy-cart__flyout-subtotal-amount",
          cartpage_containerdiv: ".rebuy-cart__flyout-subtotal", // this will be append below this target
          defaultPreText : "or 4 interest-free payments of ",
          pppricepaylater1 : "#pppricepaylater1",
          carttotalpaylater1 : "#ctppaylater1",
          defaultPriceText : "<b>Sale price $<span id='pppricepaylater1'></span></b>",
          defaultCartTotalText : "<b> $<span id='ctppaylater1'></span></b>",
          defaultImgIconsEndpart : " with <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>',
          defaultCARTDRAWERImgIconsEndpart : " with  <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>'
          
        },
        initProductPage : function(){        	
          	// recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();
           
            
            // bind Variant change event            
            document.addEventListener("variant:changed", function(e){              
              setTimeout(function(){
              		window["bppayLaterFunction"].reBindOnVariantChangeProductpage();
                	window["bppayLaterFunction"].popupInitializations();
              },1000);
            });
            
            
          }
        },
        initCartDrawerPage : function(){        	
            // recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.cartpage_containerdiv))
          {
            var d = document.createElement("div");
            d.className = "payLaterButtons";
            d.id = "cartpayLaterButtons";
            
            d.innerHTML =  this.settings.defaultPreText + this.settings.defaultCartTotalText + this.settings.defaultCARTDRAWERImgIconsEndpart;            
          
            document.querySelector(window.bppayLaterFunction.settings.cartpage_containerdiv).after(d);
            
            var cartemi = this.getCartTotalForEMI();
            if(isNaN(cartemi)){
              document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
            }else
            {
              document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
            }

            $('#cartpayLaterButtons').insertAfter( $('.rebuy-cart__flyout-actions') )

            var btns = `
              <div class="mobile-menu__section-btns">
                <a class="box-link-2" href="/pages/bariatricpal-box-of-the-month-club">Get The Monthly Box</a>
                <a class="box-link" href="/collections/bariatricpal-best-sellers">Shop The Best Sellers</a>
                <p class="free-shipping__text"><img src="https://cdn.shopify.com/s/files/1/0806/1189/t/135/assets/why_us-2.png?v=52132673617610248601674742504">Free Shipping On Orders $99+</p>
              </div>
            `;

            $('.rebuy-cart__flyout-content').append(btns)

            var interval = setInterval(function(){
              if( $('.rebuy-cart__flyout-recommendations .rebuy-product-block').length > 0 ) {
                $('.rebuy-cart__flyout-recommendations .rebuy-product-block').each(function(){
                  var el = $(this)
                  //el.find('.rebuy-product-actions').insertAfter( el.find('.rebuy-product-price') )


                  var sale =  el.find('.sale span').eq(1).text();
                  if(sale != ""  && sale != " ") {
                      sale = parseFloat(sale.substring(1, sale.length))
                      var original =  el.find('.compare-at span').eq(1).text();
                      original = parseFloat(original.substring(1, original.length))
    
                      var percentageData = (((original - sale) / original) * 100).toFixed(0);
    
                      var percent = `
                        <div class="percentage">
                          <span>Save `+ percentageData +`%</span>
                        </div>
                      `;
                      el.find('.rebuy-product-price .percentage').remove();
                      el.find('.rebuy-product-price').append(percent)
                  }
                })

                clearInterval(interval)
              }
            },1000);
          }
        },
        refreshCartHtmls : function(){
          	if(document.querySelector(this.settings.carttotalpaylater1)){
              	var cartemi = this.getCartTotalForEMI();
              	if(isNaN(cartemi)){
              		document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
                }else{
        			document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
                }
            }else{
            	window["bppayLaterFunction"].initCartDrawerPage();
              	window["bppayLaterFunction"].popupInitializations();
              
            }
        },
        reBindOnVariantChangeProductpage:function(){
        
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();           
         }
        },
        getCartTotalForEMI: function(){
          if(typeof Rebuy !== "undefined" && Rebuy.Cart && typeof Rebuy.Cart.subtotal === "function"){
            return (Rebuy.Cart.subtotal() / 4 / 100).toFixed(2);
          }
          // fallback: ajax cart
          var result = "0.00";
          $.ajax({ url: "/cart.js", async: false, success: function(cart){ result = (cart.total_price / 4 / 100).toFixed(2); } });
          return result;
        },
        getProductPagePriceEMI: function(){
        
        	return (parseFloat((parseFloat(document.querySelector(this.settings.productpage_initialprice).innerText.replace("$", "")) * 100) / 4) / 100).toFixed("2");
        },
        addPopupModalHtmls:function(){
        
          //klarna image url, klarna link
          var htmlStr= '<div class="bpplbody-blackout"></div>';
          // Popup for Afterpay
          htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pafterpay"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i> <a href="https://www.afterpay.com/purchase-payment-agreement" target="_blank" style="display: block;"><img src="https://static.afterpay.com/us-popup-medium.png" srcset="https://static.afterpay.com/us-popup-medium.png 1x, https://static.afterpay.com/us-popup-medium@2x.png 2x" style="max-width: 700px; display: block; width: 100%;" alt="Afterpay"></a>  </div>';
          
          // Popup for Klarna
          //htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pklarna"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i><a href="https://www.klarna.com/us/business/products/installments" target="_blank" style="display: block;"><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/klarna-popup-img.png?v=1619243795"  style="max-width: 650px; display: block; width: 100%;" alt="Klarna"></a></div>'
          
          
          //add html into end of body
          var d = document.createElement("div");
          d.innerHTML = htmlStr;
          document.body.appendChild(d);
          
        },
        popupInitializations:function(){
        
          	const modalTriggers = document.querySelectorAll('.popup-trigger')
            const modalCloseTrigger = document.querySelector('.bpplpopup-modal__close')
            const bodyBlackout = document.querySelector('.bpplbody-blackout')

            modalTriggers.forEach(trigger => {
              trigger.addEventListener('click', () => {
                const { popupTrigger } = trigger.dataset
                const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`)

                popupModal.classList.add('is--visible')
                bodyBlackout.classList.add('is-blacked-out')

                popupModal.querySelector('.bpplpopup-modal__close').addEventListener('click', () => {
                   popupModal.classList.remove('is--visible')
                   bodyBlackout.classList.remove('is-blacked-out')
                })

                bodyBlackout.addEventListener('click', () => {
                  // TODO: Turn into a function to close modal
                  popupModal.classList.remove('is--visible')
                  bodyBlackout.classList.remove('is-blacked-out')
                })
              })
            });
        
        }
        
      }
     
      window["bppayLaterFunction"] = cls;
      
   		if(theme.pageType == "product"){
    		cls.initProductPage();
  		}
      cls.initCartDrawerPage();
      cls.addPopupModalHtmls();
  	  cls.popupInitializations();
      
    };
    
    
    bppayLaterFunction();
    
    
  })();
  
  function shopapayclick(){
    if(document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('#shopify-installments-cta') != null)
        document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('#shopify-installments-cta').click();
    else if(document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('#shopify-installments-cta'))
        document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('#shopify-installments-cta').click();
  }
/*  KLARNA SHOP PAY AFTER PAY SCRIPT END  */
        
     
function setProductPageOnReviewLink(){
  document.querySelectorAll(".reviewlink .star-clickable a").forEach(function(item){  
        if(item.closest("div.reviewlink[data-producturl]") != null){
          var plink = item.closest("div.reviewlink[data-producturl]").attributes["data-producturl"].value;
          item.attributes.href.value = plink + "?reviews=y";
        }
  });
}

function scrollToReviews(){
  // Prodct page will scroll down to reviews when query string contains reviews.
    if(window.location.search == "?reviews=y"){  
        //if(typeof yotpo != "undefined"){
          
              setTimeout(function(){
                     window.scroll({
                        top: document.querySelector(".yotpo.yotpo-main-widget").offsetTop,
                        left:0,
                        behavior: 'smooth' 
                     });
                }, 2200);
            
          
        //}        
    }
}    
function rechargeWidgetQuickviewCallback(){
    if(document.querySelector(".rc-container-wrapper .rc_popup__label") != null){
        //document.querySelector(".rc-container-wrapper .rc_popup__label").innerText="";
        //document.querySelector(".rc-container-wrapper .rc_popup__label").classList.add("fa");
        //document.querySelector(".rc-container-wrapper .rc_popup__label").classList.add("fa-question-circle");  
    }else{
      //setTimeout(rechargeWidgetQuickviewCallback, 1000);
    }    
}
function productVariantChangePopupCallback(){
    	
      document.addEventListener("variant:changed", function(e){
  			if(e.detail.variant.available == false){
                document.querySelector("#quickshop form .notify_form").style.display = "block";
            }else{
                document.querySelector("#quickshop form .notify_form").style.display = "none";
            }
  		});   
}
function rechargeWidgetCallback()
{
	if(document.querySelector(".rc-subscription-details .rc-subscription-details__button span") != null){

        console.log("New RC widget");
		//document.querySelector(".rc-subscription-details .rc-subscription-details__button span").innerText="";
        //document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa");
        //document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa-question-circle");

      
      	var rstate = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state;
    	var currentSelectedVariant = rstate.variant;
      	if(rstate.sellingPlan != undefined){
      		// first time load
          	var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = rstate.variant;
            var curVariant = allVariants.find(s=>s.id == currentSelectedVariant);
            	var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.discounted_price);

                    var savePrice = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.unit_price);
                    var savePercent = parseInt(((curVariant.prices.compare_at_price - curVariant.prices.unit_price) * 100) / curVariant.prices.compare_at_price);
                    document.querySelector(".yousavelbl").parentElement.querySelector("ssp").innerHTML = Shopify.formatMoney(savePrice, window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat) + " ("+savePercent+"%)"
                       
                    //document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = '<span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>';
                }

                // display subscription price = curVariant.prices.discounted_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.discounted_price) * 100), Shopify.money_format);                
          
      	}
      
      	var radios = document.querySelectorAll('.rc-widget [type=radio][name=purchaseOption]');
        radios.forEach(radio => radio.addEventListener('change', () => 
        {
            var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state.variant
            var curVariant = allVariants.find(s=>s.id == currentSelectedVariant);
            if(radio.value=="onetime")
            {
                var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.unit_price);

                    var savePrice = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.unit_price);
                    var savePercent = parseInt(((curVariant.prices.compare_at_price - curVariant.prices.unit_price) * 100) / curVariant.prices.compare_at_price);
                    document.querySelector(".yousavelbl").parentElement.querySelector("ssp").innerHTML = Shopify.formatMoney(savePrice, window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat) + " ("+savePercent+"%)"
                    
                  
                    //document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>';
                }
                // display price = curVariant.prices.unit_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.unit_price) * 100), Shopify.money_format);
            }else{
                var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.discounted_price);
                  
                    var savePrice = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.discounted_price);
                    var savePercent = parseInt(((curVariant.prices.compare_at_price - curVariant.prices.discounted_price) * 100) / curVariant.prices.compare_at_price);
                    document.querySelector(".yousavelbl").parentElement.querySelector("ssp").innerHTML = Shopify.formatMoney(savePrice, window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat) + " ("+savePercent+"%)"

                    //document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>';
                }

                // display subscription price = curVariant.prices.discounted_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.discounted_price) * 100), Shopify.money_format)
            }

        }));

        
      
    }
}

$(document).ready(function(){

  if(window.location.search != null && window.location.search.includes("viewcart=true")){
    OpenSmartCart();
  }  
  refreshAnnouncementbar();
  $(".s4com-helpcenter a.js-no-transition").on("click", function(event){ event.stopPropagation(); return false; });

  productVariantChangeCallback();
  if(theme.pageType == "collection"){
        // Wait for couple of seconds. As yorpo itself loads async way.
            setTimeout(function(){
                if(yotpo.initialized == true){
                  // as its initialised, call link dom change event
                  setProductPageOnReviewLink();
                }else{
                    //Attach callback to yotpo events.
                    // assign links on reviews to product page review section.  on collection page product carts
                }
                
            }, 2000);              

          //start : To change collection product card image on selection of variant dropdown
          // Get the select dropdown element
          let selectDropdownAll = document.querySelectorAll('.product-item__info .select__container > select[name="id"]');
          selectDropdownAll.forEach(function(item, index){
              item.addEventListener('change', function() {
                  // Get the selected option
                  const selectedOption = this.options[this.selectedIndex];
                  
                  // Get the value of the data-thumbnailimgsrc attribute
                  const thumbnailImgSrc = selectedOption.getAttribute('data-thumbnailimgsrc');
                  
                  // Get the img tag element
                  let imgElement = item.closest(".product-item").querySelector('.product-item__primary-image');
              	  imgElement.srcset = "";
              	  imgElement.src = "";
                  // Update the src attribute of the img tag
                  imgElement.src = thumbnailImgSrc;
          
                  console.log("Changed - " + imgElement.src)
                  
              });
          });
          // end

    collectionFilterInitialSetup();
  }
  if(theme.pageType == "product"){
    scrollToReviews();
  }

});
// JavaScript to detect Safari on macOS
document.addEventListener("DOMContentLoaded", function() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
      document.body.classList.add('safari-macos');
  }
});

function collectionFilterInitialSetup(){
        
        // Find the 'li' element with the specified classes
        const activeFilterLiList = document.querySelectorAll('.layout__section li.collection__filter-checkbox.active-filter');
        activeFilterLiList.forEach(function(activeFilterLi, index){
          
              if (activeFilterLi) {
                // Find the closest parent element with the specified class
                const targetParent = activeFilterLi.closest('.tgl_c.collection__filter-group-list.sidebar .collection__filter-group');
              
                if (targetParent && targetParent.querySelector("button[aria-expanded='false']") != null) {
                  // Execute a click event on the target parent element
                  targetParent.querySelector("button[aria-expanded='false']").click();
                } else {
                  console.log('No parent element found with the specified class.');
                }
              } else {
                console.log('No "li" element found with the specified classes.');
              }
        });
  }


document.addEventListener('rebuy.ready', function(event){
  setTimeout(function(){
    var rebuyCustomersAlsoBoughtElement = $(".rebuy-cart__flyout-recommendations");
    rebuyCustomersAlsoBoughtElement.find('.rebuy-product-block').each(function(){
      var el = $(this)
      el.find('.rebuy-product-actions').insertAfter( el.find('.rebuy-product-price') )
      el.find('.rebuy-product-options').insertBefore( el.find('.rebuy-product-price') )
    })

    $('.rebuy-widget.widget-type-product').find('.rebuy-product-block').each(function(){
      var el = $(this)
      el.find('.product_type').insertAfter( el.find('.rebuy-product-info') )
      el.find('.rebuy-product-review').insertBefore( el.find('.rebuy-product-info') )

      if( el.find('.rebuy-select option').eq(0).text() != "Select Variant" ){
        el.find('.rebuy-select').prepend('<option value="Select Variant">Select Variant</option>')
        el.find('.rebuy-select').prop("selectedIndex", 0);
      }
    })

    $('.rebuy-widget.widget-type-dynamic-bundle').find('.rebuy-fbt-item').each(function(){
      var el = $(this)
      el.find('.product_type').insertAfter( el.find('.rebuy-product-info') )
      el.find('.rebuy-product-review').insertBefore( el.find('.rebuy-product-info > *').eq(0) )
      el.find('.rebuy-product-options').insertAfter( el.find('.rebuy-product-price') )

      // if( el.find('.rebuy-select option').eq(0).text() != "Select Variant" ){
      //   el.find('.rebuy-select').prepend('<option value="Select Variant">Select Variant</option>')
      //   el.find('.rebuy-select').prop("selectedIndex", 0);
      // }
    })
  },1000)


    var sale = $('.fbt__container .rebuy-bundle__actions-price-value .sale .money').text();
    var compare = $('.fbt__container .rebuy-bundle__actions-price-value .compare-at .money').text();

    var btnText = 'ADD ALL TO CART'
    $('.fbt__container .rebuy-button').html(btnText +' - '+ sale +' <span>'+ compare + '</span>')
    flag = false;
});


// TO FIX PRODUCT PAGE ISSUE DUE TO CONFLICT BETWEEN FORMS OF SAME PRODUCTS
var btnatctargetfreeitem;
function addtoCartFreeItemsCall(target){

       btnatctargetfreeitem = target;
       document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

          let formObj = {};
          var formElement = btnatctargetfreeitem.closest('myform[action*="/cart/add"]');
          formElement.querySelectorAll('input[type="hidden"]').forEach(input => {
            formObj[input.name] = input.value;
          });
        formObj = {
          id: formElement.querySelector("[name=id]").value,
          quantity:formElement.querySelector("[name=quantity]").value,
          properties:{"_OfferItem":"FREE GIFT"}          
        };
  
        
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(formObj),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          if (response.ok) {
            btnatctargetfreeitem.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

              var formElement = btnatctargetfreeitem.closest('myform[action*="/cart/add"]');
             document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
                }
             }));
            
          } else {
            btnatctargetfreeitem.removeAttribute('disabled');
          }

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }); 
}

//For mobile view
function checkScreenSize() {
        // find elements
        let elem = document.querySelector('footer a#bpaa');
        let footerList = document.querySelector('.footer__block-list');

        if(window.matchMedia('(max-width: 768px)').matches) {
            // if the width of browser window is less than or equal to 768px
            if(elem && footerList) {
                // append element to end of the list
                footerList.appendChild(elem);
            }
        }
}

// Run once at load
checkScreenSize();


async function updatePointsWithRetry() {
  const targetSelector = '.topbar-menu span.rpoints block.swell-point-balance';
  if(document.querySelector(targetSelector) == null)
      return;
    
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  for (let i = 1; i <= 3; i++) {
    try {
      console.log(`Attempt ${i}: Fetching Rivo points...`);

      
      if (typeof RivoJS !== 'undefined') {
        const response = await RivoJS.getCustomerDetails();
        
        
        const points = response?.points_tally ?? 0;

        
        const pointsElement = document.querySelector(targetSelector);
        if (pointsElement) {
          pointsElement.textContent = points;
          console.log(`Successfully updated points: ${points}`);
        } else {
          console.warn(`Target element not found on attempt ${i}`);
        }
      } else {
        console.warn('RivoJS is not defined yet.');
      }
    } catch (error) {
      console.error(`Error on attempt ${i}:`, error);
    }

    // run 3 times
    if (i < 3) await delay(3000);
  }
}

// header top bar point display
updatePointsWithRetry();

// Google widget and Rivo slider.

(function () {
  var TARGET_ID = 'google-merchantwidget-iframe-wrapper';
  var RIVO_ID = 'rivo-account-slideout';

  var lastState = null; // true = hidden, false = visible
  var debounceTimer = null;

  function getWidget() {
    return document.getElementById(TARGET_ID);
  }

  function isRivoOpen() {
    var el = document.getElementById(RIVO_ID);
    if (!el) return false;

    
    var isOpenClass = el.classList.contains('is-open');
    var ariaVisible = el.getAttribute('aria-hidden') === 'false';

    return isOpenClass || ariaVisible;
  }

  function applyVisibility(hide) {
    var widget = getWidget();
    if (!widget) return;

    // Prevent unnecessary DOM updates
    if (lastState === hide) return;
    lastState = hide;

    if (hide) {
      widget.style.display = 'none';
      widget.style.opacity = '0';
      widget.style.pointerEvents = 'none';
      console.log('[Widget] Hidden (Rivo open)');
    } else {
      widget.style.display = '';
      widget.style.opacity = '1';
      widget.style.pointerEvents = 'auto';
      console.log('[Widget] Visible (Rivo closed)');
    }
  }

  function evaluate() {
    try {
      var hide = isRivoOpen();
      applyVisibility(hide);
    } catch (e) {
      console.error('[Widget Toggle Error]', e);
    }
  }

  function debouncedEvaluate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(evaluate, 50);
  }

  function initObserver() {
    var observer = new MutationObserver(function (mutations) {
      // Only react if relevant change
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (
          m.type === 'childList' ||
          (m.type === 'attributes' && m.attributeName === 'class')
        ) {
          debouncedEvaluate();
          return;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    // Initial check (retry if widget loads late)
    var retryCount = 0;

    function waitForWidget() {
      var widget = getWidget();

      if (widget) {
        evaluate();
        initObserver();
      } else if (retryCount < 20) {
        retryCount++;
        setTimeout(waitForWidget, 300);
      }
    }

    waitForWidget();
  }

  init();
})();

